import classNames from 'classnames';

import FormError from './FormError';

const defaultProps = {
  rows: 15
};

const TextArea = (props) => {
  const {
    input,
    label,
    meta: { touched, error },
    rows,
    className,
    required
  } = props;
  return (
    <div className={classNames(className, touched && error && 'c7-error')}>
      <label htmlFor={`c7-${input.name}`}>
        {/* required && '*' */}
        {label} {!required && <span className="c7-optional">(optional)</span>}
        <textarea
          id={`c7-${input.name}`}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...input}
          rows={rows}
        />
      </label>
      <FormError touched={touched} error={error} />
    </div>
  );
};

TextArea.defaultProps = defaultProps;

export default TextArea;
